/**
 * Night Owl, by Sarah Drasner (MIT licensed).
 * https://github.com/sdras/night-owl-vscode-theme
 *
 * Adapted to the Monarch token scopes that openscad-language.ts actually emits:
 * comment, keyword, identifier, type.identifier, number[.float], string[.invalid],
 * delimiter and delimiter.bracket.
 */
export const NIGHT_OWL = 'night-owl';
export const nightOwlTheme = {
    base: 'vs-dark',
    inherit: true,
    rules: [
        { token: '', foreground: 'd6deeb' },
        { token: 'comment', foreground: '637777', fontStyle: 'italic' },
        { token: 'keyword', foreground: 'c792ea', fontStyle: 'italic' },
        { token: 'identifier', foreground: 'd6deeb' },
        { token: 'type.identifier', foreground: 'ffcb8b' },
        { token: 'number', foreground: 'f78c6c' },
        { token: 'number.float', foreground: 'f78c6c' },
        { token: 'string', foreground: 'ecc48d' },
        { token: 'string.invalid', foreground: 'ff5874' },
        { token: 'delimiter', foreground: 'c792ea' },
        { token: 'delimiter.bracket', foreground: 'd6deeb' },
    ],
    colors: {
        'editor.background': '#011627',
        'editor.foreground': '#d6deeb',
        'editorCursor.foreground': '#80a4c2',
        'editor.selectionBackground': '#1d3b53',
        'editor.selectionHighlightBackground': '#5f7e9779',
        'editor.lineHighlightBackground': '#0b2942',
        'editorLineNumber.foreground': '#4b6479',
        'editorLineNumber.activeForeground': '#c5e4fd',
        'editorIndentGuide.background': '#5e81ce52',
        'editorIndentGuide.activeBackground': '#7e97ac',
        'editorWhitespace.foreground': '#3b3a32',
        'editorBracketMatch.background': '#5f7e9779',
        'editorBracketMatch.border': '#7fdbca',
        'editorGutter.background': '#011627',
        'editorWidget.background': '#011627',
        'editorWidget.border': '#5f7e97',
        'editorSuggestWidget.background': '#011627',
        'editorSuggestWidget.border': '#5f7e97',
        'editorSuggestWidget.selectedBackground': '#084d81',
        'editorHoverWidget.background': '#011627',
        'editorHoverWidget.border': '#5f7e97',
        'editorError.foreground': '#ef5350',
        'editorWarning.foreground': '#c5e478',
        'scrollbarSlider.background': '#084d8180',
        'scrollbarSlider.hoverBackground': '#084d81aa',
        'scrollbarSlider.activeBackground': '#084d81',
    },
};
